import type { ReactNode } from 'react';
import { TopBar } from '@/components/layout/TopBar';

/**
 * Core-100 (phone/tablet): a page that renders no TopBar of its own has no navigation on a phone
 * — the TopBar carries the mobile route menu. `/customers` and `/customers/:id` were such pages.
 */
export function PageWithTopBar({ children }: { children: ReactNode }) {
  return (
    <div className="flex flex-col min-h-screen bg-background" data-testid="page-with-topbar">
      <TopBar />
      <main className="flex-1">{children}</main>
    </div>
  );
}
